import React, { SyntheticEvent, useCallback, useMemo, useState } from "react";
import { VideoMetadata } from "../../types/media";

interface PostVideoPlayerProps {
    src: string;
    metadata?: VideoMetadata;
    aspectRatio?: number;
    autoPlay?: boolean;
    className?: string;
    onClick?: () => void;
}

const PostVideoPlayer: React.FC<PostVideoPlayerProps> = ({
    src,
    metadata,
    aspectRatio: providedAspectRatio,
    autoPlay,
    className,
    onClick,
}) => {
    const initialRatio = useMemo(() => {
        if (providedAspectRatio !== undefined) return providedAspectRatio;
        if (metadata?.width && metadata?.height && metadata.height > 0) {
            return metadata.width / metadata.height;
        }
        return null;
    }, [providedAspectRatio, metadata?.width, metadata?.height]);

    const [aspectRatio, setAspectRatio] = useState<number | null>(initialRatio);

    const handleLoadedMetadata = useCallback((e: SyntheticEvent<HTMLVideoElement>) => {
        const video = e.currentTarget;
        if (video.videoWidth > 0 && video.videoHeight > 0) {
            setAspectRatio(video.videoWidth / video.videoHeight);
        }
    }, []);

    const isPortrait = aspectRatio !== null && aspectRatio < 1;

    return (
        <div
            className={`bg-black overflow-hidden relative mx-auto ${className ?? ""}`}
            style={{
                aspectRatio: aspectRatio ?? 16 / 9,
                width: isPortrait ? "auto" : "100%",
                maxHeight: isPortrait ? 500 : undefined,
                maxWidth: "100%",
            }}
        >
            <video
                muted
                src={src}
                controls
                autoPlay={autoPlay}
                onLoadedMetadata={handleLoadedMetadata}
                onClick={onClick}
                className={`w-full h-full object-contain ${onClick ? "cursor-pointer" : ""}`}
            />
        </div>
    );
};

export default PostVideoPlayer;
